import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-return",
  "use": "icon-return-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-return\"><defs><style type=\"text/css\"></style></defs><path d=\"M255.72 511.99 250.279 517.451 686.469 953.646 773.721 866.412 419.317 511.99 773.721 157.608 686.469 70.354 250.279 506.568Z\" p-id=\"1053\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol